/* eslint-disable no-param-reassign */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';
import { regionToCountriesMap } from 'js/constants.js';
import { Form, ConditionalRule } from '@RockwellAutomation/rockwell-meteor';

const componentName = 'software-license-form';
export class SoftwareLicenseForm extends Component {
    elements = {
        // Display
        container: this.element.querySelector(`.${componentName}__container`),
        modalContainer: this.element.closest('dialog'),
        signedOutContent: this.element.querySelector(`.${componentName}__content--unauthenticated`),
        formSuccessContent: this.element.querySelector(`.${componentName}__content--success`),
        formIneligibleContent: this.element.querySelector(`.${componentName}__content--ineligible`),
        formLimitReachedContent: this.element.querySelector(`.${componentName}__content--limit-reached`),
        formErrorContent: this.element.querySelector(`.${componentName}__content--error`),
        formContent: this.element.querySelector(`.${componentName}__content--form`),
        loaderContent: this.element.querySelector(`.${componentName}__content--loading`),
        // Form
        form: this.element.querySelector('form'),
        formSubmitButton: this.element.querySelector(`.${componentName}__form-submit`),
        signInLink: this.element.querySelector(`.${componentName}__content-action--sign-in`),
        closeDialogButtons: this.element.querySelectorAll(`.${componentName}__content-action--cancel`),
        defaultCountryOptions: this.element.querySelector(`.${componentName}-default-options--country`),
        countrySelect: this.element.querySelector('select[name="$Country"]'),
        stateSelect: this.element.querySelector('select[name="$StateorProvince"]'),
        // Hidden Inputs
        bpidInput: this.element.querySelector('input[name="$Question2Text"]'),
        hiddenEmailInput: this.element.querySelector('input[name="$PrepopEmailAddress"]'),
        urlInput: this.element.querySelector('input[name="$FormURL"]'),
        formNameInput: this.element.querySelector('input[name="elqFormName"]'),
        regionInput: this.element.querySelector('input[name="$Region"]'),
        confirmationEmailIdInput: this.element.querySelector('input[name="$ConfirmationEmailID"]'),
    };

    state = {
        isSignedIn: false,
        userInfo: {
            origin: 'Marketing',
            isTest: false,
            shipToBpid: '',
            softwarePortalLoginEmail: '',
            catalogNumber: '',
            intendedUse: '',
            contactFirstName: '',
            contactLastName: '',
            contactEmail: '',
            contactPhone: '',
            contactCompany: '',
            contactAddress1: '',
            contactAddress2: '',
            contactCity: '',
            contactProvince: 'N/A',
            contactPostCode: '',
            contactCountryCode: '',
            contactCountryName: '',
            contactFax: '',
        },
        userLicenseStatus: 'eligible',
        stateInputType: 'select',
    };

    constants = {
        eloquaEndpoint: '',
        licenseServletEndpoint: '/bin/rockwell-automation/software-license',
        theme: 'ra',
        requiredFields: [
            'origin',
            'softwarePortalLoginEmail',
            'catalogNumber',
            'intendedUse',
            'contactFirstName',
            'contactLastName',
            'contactEmail',
            'contactCompany',
            'contactAddress1',
            'contactCity',
            'contactProvince',
            'contactPostCode',
            'contactCountryCode',
            'contactCountryName',
        ],
        formFieldToUserInfoMap: {
            $FirstName: 'contactFirstName',
            $LastName: 'contactLastName',
            $EmailAddress: 'contactEmail',
            $Telephone: 'contactPhone',
            $Company: 'contactCompany',
            $AddressLine1: 'contactAddress1',
            $AddressLine2: 'contactAddress2',
            $City: 'contactCity',
            $StateorProvince: 'contactProvince',
            $Postcode: 'contactPostCode',
            $Country: 'contactCountryName',
            $Fax: 'contactFax',
            $Comments: 'intendedUse',
        },
        inputMaxLengths: {
            $FirstName: 40,
            $LastName: 40,
            $Company: 60,
            $AddressLine1: 60,
            $AddressLine2: 60,
            $City: 32,
            $Postcode: 10,
            $Question3Text: 20,
            $Comments: 250,
            $Telephone: 20,
            $EmailAddress: 128,
        },
        regionToConfirmationEmailIdMap: {
            default: 67299,
            NA: this.elements.container.dataset.confirmationEmailIdNa,
            EMEA: this.elements.container.dataset.confirmationEmailIdEmea,
            APAC: this.elements.container.dataset.confirmationEmailIdApac,
            LA: this.elements.container.dataset.confirmationEmailIdLatam,
        },
    };

    setInputMaxLengths = () => {
        Object.keys(this.constants.inputMaxLengths).forEach((key) => {
            const input = this.elements.form.querySelector(`input[name="${key}"]`);
            if (input) {
                input.maxLength = this.constants.inputMaxLengths[key];
            }
        });
    };

    checkSignInStatus = () => {
        const loggedInData = {};

        if (window.userData) {
            this.state.isSignedIn = true;
            loggedInData.firstName = window.userData.firstName;
            loggedInData.lastName = window.userData.lastName;
            loggedInData.email = window.userData.email;
            loggedInData.phone = window.userData.phone;
            loggedInData.company = window.userData.company;
            loggedInData.address = window.userData.address;
            loggedInData.city = window.userData.city;
            loggedInData.region = window.userData.region;
            loggedInData.zip = window.userData.zip;
            loggedInData.countryCode = window.userData.countryCode;
            loggedInData.country = window.userData.country;
            loggedInData.bpid = window.userData.bpid;
        } else if (localStorage.getItem('loggedInData')) {
            try {
                const loginObject = JSON.parse(localStorage.getItem('loggedInData'));
                loggedInData.firstName = loginObject.firstName;
                loggedInData.lastName = loginObject.lastName;
                loggedInData.email = loginObject.email;
                loggedInData.phone = loginObject.phone;
                loggedInData.company = loginObject.company;
                loggedInData.address = loginObject.address;
                loggedInData.city = loginObject.city;
                loggedInData.region = loginObject.region;
                loggedInData.zip = loginObject.zip;
                loggedInData.countryCode = loginObject.countryCode;
                loggedInData.country = loginObject.country;
                loggedInData.bpid = loginObject.bpid;
                this.state.isSignedIn = true;
            } catch (e) {
                console.warn('Error parsing loggedInData from localStorage', e);
            }
        }
        if (loggedInData.email) {
            this.state.userInfo.contactFirstName = loggedInData.firstName || '';
            this.state.userInfo.contactLastName = loggedInData.lastName || '';
            this.state.userInfo.contactEmail = loggedInData.email || '';
            this.state.userInfo.softwarePortalLoginEmail = loggedInData.email || '';
            this.state.userInfo.contactPhone = loggedInData.phone || '';
            this.state.userInfo.contactCompany = loggedInData.company || '';
            this.state.userInfo.contactAddress1 = loggedInData.address || '';
            this.state.userInfo.contactCity = loggedInData.city || '';
            this.state.userInfo.contactProvince = loggedInData.region || '';
            this.state.userInfo.contactPostCode = loggedInData.zip || '';
            this.state.userInfo.contactCountryCode = loggedInData.countryCode || '';
            this.state.userInfo.contactCountryName = loggedInData.country || '';
            this.state.userInfo.shipToFirstName = loggedInData.firstName || '';
            this.state.userInfo.shipToBpid = loggedInData.bpid || '';
        }
    };

    checkLicenseEligibility = async () => {
        let status = 'error';
        const licenseRequestUrl = new URL(this.constants.licenseServletEndpoint, window.location.origin);
        Object.keys(this.state.userInfo).forEach((key) => {
            licenseRequestUrl.searchParams.append(key, this.state.userInfo[key]);
        });
        try {
            const response = await fetch(licenseRequestUrl, {
                method: 'GET',
            });
            if (response.ok) {
                const data = await response.json();
                if (data.message == 'Success') {
                    status = 'success';
                } else if (data.id == 3001) {
                    status = 'limit-reached';
                } else if (data.id == 3004) {
                    status = 'ineligible';
                } else {
                    status = 'error';
                }
            } else {
                status = 'error';
            }
        } catch (error) {
            console.warn('Error fetching license eligibility:', error);
            status = 'error';
        }
        window.digitalData = window.digitalData || [];
        const formEvent = {
            event: 'formSubmit',
            formSubmitDetail: {
                status: status === 'success' ? status : 'error',
                formName: this.elements.modalContainer.id,
            }
        };
        if (status !== 'success') {
            formEvent.formSubmitDetail.errorMessage = status;
        }
        window.digitalData.push(formEvent);
        return status;
    };

    postToEloqua = async (formData) => {
        if (!this.constants.eloquaEndpoint) {
            console.warn('Eloqua endpoint is not set.');
            return null;
        }
        try {
            const eloquaRequestUrl = new URL(this.constants.eloquaEndpoint);
            const eloquaPostBody = {};
            formData.entries().forEach(([key, value]) => {
                if (key === '$Telephone') {
                    // Prepend the selected country code once. The visible field
                    // keeps only the user-entered number (getFullTelephone is
                    // overridden in initDom so the engine no longer writes the
                    // combined value back into the field).
                    eloquaPostBody[key] = `${formData.get('$Telephone--country-code')} ${value}`;
                } else if (key === '$PrepopEmailAddress') {
                    eloquaPostBody[key] = value;
                    eloquaPostBody.$EmailAddress = value;
                } else if (key === '$StateorProvince') {
                    if (this.state.stateInputType === 'select') {
                        eloquaPostBody.$StateorProvince = value;
                    }
                } else if (key !== '$Telephone--country-code') {
                    eloquaPostBody[key] = value;
                }
            });

            // Check for UTM parameters in query string
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('utm_campaign')) {
                eloquaPostBody.utm_campaign = urlParams.get('utm_campaign');
            }
            if (urlParams.get('utm_creative')) {
                eloquaPostBody.utm_creative = urlParams.get('utm_creative');
            }
            if (urlParams.get('utm_medium')) {
                eloquaPostBody.utm_medium = urlParams.get('utm_medium');
            }
            if (urlParams.get('utm_placement')) {
                eloquaPostBody.utm_placement = urlParams.get('utm_placement');
            }
            if (urlParams.get('utm_source')) {
                eloquaPostBody.utm_source = urlParams.get('utm_source');
            }
            if (urlParams.get('utm_content')) {
                eloquaPostBody.utm_content = urlParams.get('utm_content');
            }
            if (urlParams.get('utm_term')) {
                eloquaPostBody.utm_term = urlParams.get('utm_term');
            }

            const response = await fetch(eloquaRequestUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                mode: 'no-cors',
                body: new URLSearchParams(eloquaPostBody),
            });
            const data = await response.text();
            if (!response.ok) {
                console.warn('Eloqua error:', data);
            }
            return data;
        } catch (error) {
            console.warn('Error posting to Eloqua:', error);
            return null;
        }
    };

    setUserInfo = (formData) => {
        formData.entries().forEach(([key, value]) => {
            if (this.constants.formFieldToUserInfoMap[key]) {
                if (key === '$Telephone') {
                    // Prepend the selected country code once for the license
                    // request payload; the visible field keeps only the number.
                    this.state.userInfo[this.constants.formFieldToUserInfoMap[key]] = `${formData.get('$Telephone--country-code')} ${value}`;
                } else if (key === '$StateorProvince') {
                    if (this.state.stateInputType === 'none') {
                        this.state.userInfo[this.constants.formFieldToUserInfoMap[key]] = 'N/A';
                    } else if (this.state.stateInputType === 'select') {
                        this.state.userInfo[this.constants.formFieldToUserInfoMap[key]] = value || this.state.userInfo[this.constants.formFieldToUserInfoMap[key]];
                    }
                } else {
                    this.state.userInfo[this.constants.formFieldToUserInfoMap[key]] = value || this.state.userInfo[this.constants.formFieldToUserInfoMap[key]];
                }
            }
        });
    };

    presetFormFields = () => {
        const formFields = this.elements.form.querySelectorAll('input, select');
        formFields.forEach((field) => {
            const fieldName = field.getAttribute('name');
            if (this.constants.formFieldToUserInfoMap[fieldName]) {
                const userInfoKey = this.constants.formFieldToUserInfoMap[fieldName];
                if (this.state.userInfo[userInfoKey]) {
                    if (this.constants.inputMaxLengths[fieldName]) {
                        field.value = this.state.userInfo[userInfoKey].slice(0, this.constants.inputMaxLengths[fieldName]);
                    } else {
                        field.value = this.state.userInfo[userInfoKey];
                    }
                }
            }
        });
    };

    // handleValidation and focusFirstInvalidField handled natively by Form Engine onSubmit interception.

    addEventListeners = () => {
        this.elements.form.addEventListener('submit', async (event) => {
            if (event.defaultPrevented) return;
            event.preventDefault();

            // Form Engine intercept. Calculate hidden state pre-flight.
            const stateFieldWrapper = this.elements.stateSelect ? this.elements.stateSelect.closest(`.${this.constants.theme}-formfield`) : null;
            if (stateFieldWrapper && stateFieldWrapper.classList.contains('hidden')) {
                this.state.stateInputType = 'none';
            } else {
                this.state.stateInputType = 'select';
            }

            this.elements.formSubmitButton.classList.add('loading');
            const formData = new FormData(this.elements.form);
            this.setUserInfo(formData);

            await this.postToEloqua(formData);
            const response = await this.checkLicenseEligibility();

            this.elements.formContent.classList.remove('active');
            switch (response) {
            case 'success':
                this.elements.formSuccessContent.classList.add('active');
                break;
            case 'ineligible':
                this.elements.formIneligibleContent.classList.add('active');
                break;
            case 'limit-reached':
                this.elements.formLimitReachedContent.classList.add('active');
                break;
            case 'error':
                this.elements.formErrorContent.classList.add('active');
                break;
            default:
                break;
            }
            this.elements.formSubmitButton.classList.remove('loading');
        });

        this.elements.form.querySelectorAll('select').forEach((select) => {
            select.addEventListener('change', () => {
                if (select.value) {
                    select.classList.add('has-value');
                } else {
                    select.classList.remove('has-value');
                }
            });
        });

        this.elements.closeDialogButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.elements.modalContainer.close();
            });
        });
    };

    reOpenModal = () => {
        const modalId = this.elements.modalContainer?.id;

        if (modalId && window.location.hash === `#${modalId}` && window.userData) {
            this.elements.modalContainer.showModal();
        }
    };

    initDom = () => {
        // Check sign-in status
        this.checkSignInStatus();
        if (!this.state.isSignedIn) {
            this.elements.loaderContent.classList.remove('active');
            this.elements.signedOutContent.classList.add('active');
            this.elements.signInLink.addEventListener('click', () => {
                window.location.hash = `#${this.elements.modalContainer.id}`;
                if (document.querySelector('.account-menu__sign-in')) {
                    document.querySelector('.account-menu__sign-in').click();
                } else if (localStorage.getItem('adfsLogin')) {
                    window.location.href = localStorage.getItem('adfsLogin');
                }
            });
            return;
        }

        this.setInputMaxLengths();

        // Set data values
        this.state.userInfo.origin = this.elements.container.getAttribute('data-origin') || this.state.userInfo.origin;
        this.state.userInfo.catalogNumber = this.elements.container.getAttribute('data-catalog-number') || this.state.userInfo.catalogNumber;
        this.constants.theme = this.elements.container.getAttribute('data-theme') || this.constants.theme;
        this.constants.eloquaEndpoint = this.elements.container.getAttribute('data-eloqua-endpoint') || this.constants.eloquaEndpoint;
        this.elements.urlInput.value = window.location.origin + window.location.pathname;
        this.elements.bpidInput.value = this.state.userInfo.shipToBpid || this.elements.bpidInput.value;
        this.elements.hiddenEmailInput.value = this.state.userInfo.softwarePortalLoginEmail || this.elements.hiddenEmailInput.value;

        // Init form fields
        if (this.elements.countrySelect && this.elements.countrySelect.querySelectorAll('option').length <= 1) {
            this.elements.defaultCountryOptions.querySelectorAll('option').forEach((option) => {
                this.elements.countrySelect.appendChild(option);
            });
        }
        this.elements.defaultCountryOptions.remove();

        this.presetFormFields();

        // Mapping legacy form class names
        const adapterMap = {
            $EmailAddress: 'email',
            $FirstName: 'first-name',
            $LastName: 'last-name',
            $Company: 'company',
            $AddressLine1: 'address1',
            $AddressLine2: 'address2',
            $City: 'city',
            $StateorProvince: 'state',
            $Postcode: 'zip-postal-code',
            $Country: 'country',
            $Telephone: 'telephone',
            '$Telephone--country-code': 'country-code',
            $Question3Text: 'fax',
            $Comments: 'comments'
        };

        Object.entries(adapterMap).forEach(([legacyName, canonicalName]) => {
            const input = this.elements.form.querySelector(`[name="${legacyName}"]`);
            if (input) {
                const wrapper = input.closest(`.${this.constants.theme}-formfield`);
                if (wrapper) {
                    wrapper.classList.add(`${this.constants.theme}-formfield--${canonicalName}`);
                }
            }
        });

        this.elements.form.classList.add(`${this.constants.theme}-form`);

        if (this.elements.stateSelect) {
            this.elements.stateSelect.value = this.state.userInfo.contactProvince || this.elements.stateSelect.value;
        }

        this.elements.form.querySelectorAll('select').forEach((select) => {
            if (select.value) {
                select.classList.add('has-value');
            } else {
                select.classList.remove('has-value');
            }
        });

        this.elements.form.querySelector('input[name="$EmailAddress"]').disabled = true;
        this.elements.form.querySelector('input[name="$EmailAddress"]').classList.add(`${this.constants.theme}-input__input--disabled`);

        const regionRule = new ConditionalRule('country', 'country', (triggerField) => {
            const selectedCountry = triggerField.getValue();
            let selectedRegion = 'NA';
            Object.keys(regionToCountriesMap).forEach((region) => {
                if (regionToCountriesMap[region].includes(selectedCountry)) {
                    selectedRegion = region;
                    if (this.constants.regionToConfirmationEmailIdMap[region]) {
                        this.elements.confirmationEmailIdInput.value = this.constants.regionToConfirmationEmailIdMap[region];
                    } else {
                        this.elements.confirmationEmailIdInput.value = this.constants.regionToConfirmationEmailIdMap.default;
                    }
                }
            });
            this.elements.regionInput.value = selectedRegion;
            this.elements.formNameInput.value = `GatedContent-${selectedRegion}`;
        });

        this.formEngine = new Form(this.elements.form, { customConditionalRules: [regionRule] });
        this.formEngine.init();

        // The Meteor form engine's submit handler rewrites the telephone field
        // to `${countryCode} ${number}` (see getFullTelephone), which both
        // mutates the visible field and prepends the country code to the
        // submitted value. Override it to keep only the user-entered number;
        // the country code remains available in its own dropdown.
        if (typeof this.formEngine.getFullTelephone === 'function') {
            this.formEngine.getFullTelephone = () => this.formEngine.getFormField('telephone')?.getValue() || '';
        }

        this.formEngine.getFormField('casl').hide();
        this.formEngine.getFormField('gdpr').hide();

        this.elements.loaderContent.classList.remove('active');
        this.elements.formContent.classList.add('active');
    };

    /**
     * Initialize Component
     */
    init = () => {
        if (typeof getPiraObj === 'function' || window.location.hostname.includes('localhost')) {
            if (this.elements.container.dataset.initialized !== 'true') {
                this.elements.container.dataset.initialized = 'true';
                this.initDom();
                this.addEventListeners();
            }
        } else {
            document.addEventListener('piraLoadedSynced', () => {
                if (this.elements.container.dataset.initialized !== 'true') {
                    this.elements.container.dataset.initialized = 'true';
                    this.initDom();
                    this.addEventListeners();
                }
            });

            // If piraLoadedSynced doesn't fire, init after 10 seconds
            setTimeout(() => {
                if (this.elements.container.dataset.initialized !== 'true') {
                    this.elements.container.dataset.initialized = 'true';
                    this.initDom();
                    this.addEventListeners();
                }
            }, 10000);
        }

        // Re-open modal after user clicked modal Sign In button and returns from authenticating
        if (document.readyState === 'complete') {
            this.reOpenModal();
        } else {
            window.addEventListener('load', this.reOpenModal);
        }
    };
}

registerComponent(`.${componentName}`, SoftwareLicenseForm);
